import { render, staticRenderFns } from "./PaymentSelecter.vue?vue&type=template&id=f64c491a&scoped=true&"
import script from "./PaymentSelecter.vue?vue&type=script&lang=js&"
export * from "./PaymentSelecter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSelecter.vue?vue&type=style&index=0&id=f64c491a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c491a",
  null
  
)

export default component.exports